import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import AdminSidebar from '../../components/AdminSidebar';
import '../../components/AdminTables.css';

function SolicitationsAdmin() {
  const [documents, setDocuments] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [committees, setCommittees] = useState([]);
  const [query, setQuery] = useState('');
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const res = await fetch('/api/documents/type/' + encodeURIComponent('Statement of Solicitation'));
        if (res.ok) {
          const data = await res.json();
          setDocuments(data.sort((a,b) => new Date(b.Date) - new Date(a.Date)));
        }
      } catch (err) { console.error(err); }
    };

    const fetchCommittees = async () => {
      try {
        const res = await fetch('/api/committee');
        if (res.ok) setCommittees(await res.json());
      } catch (err) { console.error(err); }
    };

    fetchDocs();
    fetchCommittees();
  }, []);

  const addAccountToCandidate = async (acctNum, acctName) => {
    let acct = window.prompt('Enter candidate AcctNum to add this committee to:');
    if (!acct) { setMessage('Add cancelled'); return; }
    acct = acct.trim();
    if (!/^[0-9]+$/.test(acct)) { setMessage('Invalid AcctNum'); return; }
    try {
      const res = await fetch('/api/candidates/' + acct + '/accountlist', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accountName: acctName, accountNum: acctNum })
      });
      const data = await res.json();
      if (!res.ok) {
        setMessage('Error: ' + (data.error || data.msg || 'Failed'));
        return;
      }
      setMessage('Added ' + acctName + ' (' + acctNum + ') to candidate ' + acct);
    } catch (err) {
      setMessage('Network error');
    }
  };

  const filteredCommittees = committees.filter(c => {
    if (!query) return true;
    const q = query.toLowerCase();
    return String(c.AcctNum).includes(q) || (c.Name && c.Name.toLowerCase().includes(q));
  }).slice(0, 12);

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
  <div style={{ display: 'flex', maxWidth: '1200px', margin: '8px auto' }}>
        <AdminSidebar />

        <main style={{ flex: 1, padding: 12 }}>
          <h2>Solicitations</h2>

          {/* Top row: Committee search with live suggestions */}
          <div style={{ marginTop: 12, marginBottom: 12, position: 'relative', maxWidth: 900 }}>
            <label style={{ display: 'block', marginBottom: 6 }}>Find Committee</label>
            <input
              placeholder="Search committees by name or acctnum"
              value={query}
              onChange={e => setQuery(e.target.value)}
              style={{ padding: 10, width: '100%', borderRadius: 6, border: '1px solid rgba(0,0,0,0.12)' }}
            />

            {query && filteredCommittees.length > 0 && (
              <div style={{ position: 'absolute', left: 0, right: 0, top: 68, background: '#fff', boxShadow: '0 6px 18px rgba(0,0,0,0.06)', borderRadius: 6, maxHeight: 300, overflow: 'auto', zIndex: 40 }}>
                <table className="admin-table" style={{ margin: 0 }}>
                  <tbody>
                    {filteredCommittees.map(c => (
                      <tr key={c._id} style={{ cursor: 'default' }}>
                        <td style={{ width: 110 }}>{c.AcctNum}</td>
                        <td style={{ minWidth: 240 }}>{c.Name}</td>
                        <td style={{ textAlign: 'right' }}>
                          <div className="admin-actions">
                            <button className="btn btn-edit" onMouseDown={(e) => e.preventDefault()} onClick={() => addAccountToCandidate(c.AcctNum, c.Name)}>Add</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Below: two-column layout - documents on left (50%), PDF viewer on right (50%) */}
          <div style={{ display: 'flex', gap: 16 }}>
            <section style={{ flex: '0 0 50%', maxWidth: '50%' }}>
              <h3 style={{ marginTop: 0 }}>Statement of Solicitation Documents</h3>
              <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
                <table className="admin-table">
                  <thead>
                    <tr><th style={{ width: 140 }}>Date</th><th>Document</th></tr>
                  </thead>
                  <tbody>
                    {documents.map(doc => (
                      <tr key={doc._id} onClick={() => setSelectedDoc(doc)} style={{ cursor: 'pointer' }}>
                        <td>{new Date(doc.Date).toLocaleDateString()}</td>
                        <td>{doc.DocDesc || doc.Filename}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>

            <section style={{ flex: '1 1 50%', maxWidth: '50%' }}>
              <h3 style={{ marginTop: 0 }}>PDF Viewer</h3>
              {selectedDoc ? (
                <iframe title="doc-view" src={`/docs/${selectedDoc.FilePath}`} style={{ width: '100%', height: '70vh', border: '1px solid rgba(0,0,0,0.06)' }} />
              ) : (
                <div style={{ padding: 12, border: '1px dashed rgba(0,0,0,0.06)', height: '70vh' }}>Select a document to view</div>
              )}
            </section>
          </div>

          {message && <div style={{ marginTop: 12 }}>{message}</div>}
        </main>
      </div>
    </div>
  );
}

export default SolicitationsAdmin;
